import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import './OperationReport.scss';

import commonConstant from '../../common/_commonConstant';
import { getCookieToken, randomNumber, trimSpace } from '../../common/_commonFunction';
import {
  fetchGetParkingReport,
  fetchGetParkingStatus,
  fetchGetParkingStatusById,
  fetchSearchVehiclePlateOrParkingRefInOperationReport,
  fetchGetIoTDevices,
} from '../../actions';
import { CreateParking, Loading, ParkingDetail } from '../../components';
import {
  Badges,
  vehicleLicensePlate,
  Checkbox,
  createBy,
  customerType,
  DatePicker,
  dateYYYYMMDD,
  dateYYYYMMDDTimeHHMMSS,
  history,
  IconVehicle,
  InputWithIcon,
  isAlreadyExist,
  isOperation,
  labelVehicleType,
  minutesToHHMMSS,
  Modal,
  parkingID,
  parkingTimeIn,
  parkingTimeOut,
  Table,
  tagProblem,
  totalCar,
  totalMotorcycle,
  totalVehicles,
  validateToShowDash,
  validateVehiclePlate,
  vehicleType,
  vehicleTypeIconName,
  // buildingID,
  totalRecords,
  vehicleProvince,
  RadioButton,
} from '../../helpers';

const columnHeader = [
  { 'label': 'ลำดับที่', 'className': 'number', 'sort': false, 'key': '' },
  { 'label': 'Parking ref. no.', 'className': 'ref-no', 'sort': true, 'key': 'parking-ref-no' },
  { 'label': 'เลขทะเบียน', 'className': 'vehicle-plate', 'sort': false, 'key': '' },
  { 'label': 'จังหวัด', 'className': 'vehicle-province', 'sort': false, 'key': '' },
  { 'label': 'ประเภทยานพาหนะ', 'className': 'vehicle-type', 'sort': false, 'key': '' },
  { 'label': 'วันเวลาเข้า', 'className': 'time-in', 'sort': true, 'key': 'parking-time-in' },
  { 'label': 'วันเวลาออก', 'className': 'time-out', 'sort': true, 'key': 'parking-time-out' },
  { 'label': 'เวลาจอด', 'className': 'time-park', 'sort': false, 'key': '' },
  { 'label': 'สถานะสมาชิก', 'className': 'customer-type', 'sort': false, 'key': '' },
  { 'label': 'สร้างโดย', 'className': 'create-by', 'sort': false, 'key': '' },
  { 'label': 'ปัญหาที่พบ', 'className': 'problem', 'sort': false, 'key': '' },
  { 'label': '', 'className': 'view-detail', 'sort': false, 'key': '', 'keyFuncName': 'viewDetail' },
];

class OperationReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
      'sort': commonConstant.defaultSortParkingReport,
      'inputFilter': '',
      'filter': [],
      'filterCheckbox': {
        ...JSON.parse(commonConstant.defaultFilterParkingStatus),
        ...JSON.parse(commonConstant.defaultFilterCreateBy),
        ...JSON.parse(commonConstant.defaultFilterProblem),
        ...JSON.parse(commonConstant.defaultFilterVehicleType),
        ...JSON.parse(commonConstant.defaultFilterCustomerType),
      },
      'selectFilterCheckbox': {
        ...JSON.parse(commonConstant.defaultFilterParkingStatus),
        ...JSON.parse(commonConstant.defaultFilterCreateBy),
        ...JSON.parse(commonConstant.defaultFilterProblem),
        ...JSON.parse(commonConstant.defaultFilterVehicleType),
        ...JSON.parse(commonConstant.defaultFilterCustomerType),
      },
      'filterInput': [],
      'fromDate': dateYYYYMMDD(new Date()),
      'toDate': dateYYYYMMDD(new Date()),
      'selectTypeDate': 1,
      'loading': true,
      'modal': null,
      'sumFilterModal': 0,
      'showAutoFill': false,
      'dataAutoFill': null,
      'typeSearch': 'vehicleLicensePlate',
    };
    this.passFuncBody = [
      (data, objToPassFuncBody, pageSize, pageNumber, index) => ((pageSize * (pageNumber - 1)) + (index + 1)),
      data => validateToShowDash(data.parkingRefNo),
      data => validateToShowDash(vehicleLicensePlate(data)),
      data => validateToShowDash(vehicleProvince(data)),
      data => validateToShowDash(labelVehicleType(data.vehicle)),
      data => validateToShowDash(dateYYYYMMDDTimeHHMMSS(parkingTimeIn(data))),
      data => validateToShowDash(dateYYYYMMDDTimeHHMMSS(parkingTimeOut(data))),
      data => validateToShowDash(data.parkingTotalParkingTimeMinutes || data.parkingTotalParkingTimeMinutes === 0 ? minutesToHHMMSS(data.parkingTotalParkingTimeMinutes) : null),
      data => validateToShowDash(customerType(data, props.match.params.buildingID)),
      data => createBy(data),
      data => validateToShowDash(tagProblem(data)),
      () => <span key={randomNumber()}>view details</span>,
    ];
    if (!getCookieToken()) {
      return history.push(commonConstant.pathLogout);
    }
  }

  UNSAFE_componentWillMount() {
    if (this.props.getProfile.data && isOperation(this.props.getProfile.data)) {
      this.handleClearState();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { typeSearch } = this.state;
    const {
      getParkingReport,
      getProfile,
      getParkingStatusById,
      getParkingStatus,
      createParking,
      carExit,
      createProblem,
      updateProblem,
      deleteProblem,
      getVehicleLicensePlate,
      searchVehiclePlateOrParkingRefInOperationReport,
      iotDevices,
      'match': { params },
    } = this.props;

    if (nextProps.getParkingReport && nextProps.getParkingReport && nextProps.getParkingReport !== getParkingReport) {
      if (!nextProps.iotDevices.data) {
        return this.props.dispatch(fetchGetIoTDevices(params.buildingID, commonConstant.iotDeviceParkingGate));
      }
      return this.setState({ 'loading': false, 'dataAutoFill': null });
    } else if (nextProps.getProfile && nextProps.getProfile !== getProfile) {
      if (nextProps.getProfile.status === 200 && isOperation(nextProps.getProfile.data)) {
        return this.handleClearState(nextProps);
      }
      return history.push(commonConstant.pathCheckRedirect);
    } else if (nextProps.getParkingStatusById && nextProps.getParkingStatusById && nextProps.getParkingStatusById !== getParkingStatusById) {
      if (isAlreadyExist(nextProps.getParkingStatusById.data)) {
        return this.setState({ 'loading': false, 'modal': 'viewDetail' });
      }
      return this.props.dispatch(fetchGetParkingStatus(parkingID(nextProps.getParkingStatusById.data)));
    } else if (nextProps.getParkingStatus && nextProps.getParkingStatus && nextProps.getParkingStatus !== getParkingStatus) {
      return this.setState({ 'loading': false, 'modal': 'viewDetail' });
    } else if (nextProps.createParking && nextProps.createParking !== createParking) {
      if (nextProps.createParking.status === 200) {
        this.setState({ 'loading': true });
        this.handleCallUpdateDataReport();
        return this.props.dispatch(fetchGetParkingStatusById(parkingID(nextProps.createParking.data)));
      }
    } else if (nextProps.carExit && nextProps.carExit !== carExit) {
      if (nextProps.carExit.status === 200) {
        this.setState({ 'loading': true });
        this.handleCallUpdateDataReport();
        return this.props.dispatch(fetchGetParkingStatusById(parkingID(nextProps.carExit.data)));
      }
    } else if (
      (nextProps.createProblem && nextProps.createProblem !== createProblem) ||
      (nextProps.updateProblem && nextProps.updateProblem !== updateProblem) ||
      (nextProps.deleteProblem && nextProps.deleteProblem !== deleteProblem)
    ) {
      if (
        (nextProps.createProblem.status === 200 && nextProps.createProblem.data.parkingID === parkingID(getParkingStatusById.data)) ||
        (nextProps.updateProblem.status === 200 && nextProps.updateProblem.data.parkingID === parkingID(getParkingStatusById.data)) ||
        (nextProps.deleteProblem.status === 200)
      ) {
        this.setState({ 'loading': true });
        this.handleCallUpdateDataReport();
        return this.props.dispatch(fetchGetParkingStatusById(parkingID(nextProps.getParkingStatusById.data)));
      }
    } else if (nextProps.getVehicleLicensePlate && nextProps.getVehicleLicensePlate.status === 200 && nextProps.getVehicleLicensePlate !== getVehicleLicensePlate) {
      return this.handleItemsAutoFill(nextProps.getVehicleLicensePlate);
    } else if (
      nextProps.searchVehiclePlateOrParkingRefInOperationReport
      && nextProps.searchVehiclePlateOrParkingRefInOperationReport !== searchVehiclePlateOrParkingRefInOperationReport
      && nextProps.searchVehiclePlateOrParkingRefInOperationReport.metadata
      && nextProps.searchVehiclePlateOrParkingRefInOperationReport.metadata.searchKeywords
    ) {
      const keyword = nextProps.searchVehiclePlateOrParkingRefInOperationReport.metadata.searchKeywords[typeSearch === 'vehicleLicensePlate' ? 'vehicleLicensePlates' : 'parkingRefNos'];
      this.setState({
        'showAutoFill': true,
        'dataAutoFill': keyword !== '' && keyword.split(',').map((ele, index) => (
          <div className="item" key={randomNumber()} onClick={() => this.handleFilterInput(ele)}>
            <span className="text" id={`search-auto-fill-${index}`}>
              {ele}
            </span>
          </div>
        )),
      });
    } else if (nextProps.iotDevices && nextProps.iotDevices !== iotDevices) {
      return this.setState({ 'loading': false });
    }
  }

  handlePageChange = pageNumber => {
    const { fromDate, toDate, pageSize, sort } = this.state;

    this.setState({ pageNumber, 'loading': true });
    return this.props.dispatch(fetchGetParkingReport(
      this.props.match.params.buildingRefNo,
      this.handleFilterByType('vehicleLicensePlate'),
      this.handleFilterByType('parking-status'),
      this.handleFilterByType('create-by'),
      this.handleFilterByType('problem'),
      fromDate ? dateYYYYMMDD(fromDate) : null,
      toDate ? dateYYYYMMDD(toDate) : null,
      pageSize.value,
      (pageSize.value * pageNumber) - pageSize.value >= 0 ? (pageSize.value * pageNumber) - pageSize.value : 0,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      this.handleFilterByType('vehicle-type'),
      this.handleFilterByType('customer-type'),
      this.handleFilterByType('parkingRef'),
    ));
  }

  handlePageSize = pageSize => {
    const { fromDate, toDate, sort } = this.state;

    this.setState({ pageSize, 'pageNumber': 1, 'loading': true });
    return this.props.dispatch(fetchGetParkingReport(
      this.props.match.params.buildingRefNo,
      this.handleFilterByType('vehicleLicensePlate'),
      this.handleFilterByType('parking-status'),
      this.handleFilterByType('create-by'),
      this.handleFilterByType('problem'),
      fromDate ? dateYYYYMMDD(fromDate) : null,
      toDate ? dateYYYYMMDD(toDate) : null,
      pageSize.value,
      0,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      this.handleFilterByType('vehicle-type'),
      this.handleFilterByType('customer-type'),
      this.handleFilterByType('parkingRef'),
    ));
  }

  handleSort = sort => {
    const { fromDate, toDate, pageSize, pageNumber } = this.state;

    this.setState({ sort, 'loading': true });

    return this.props.dispatch(fetchGetParkingReport(
      this.props.match.params.buildingRefNo,
      this.handleFilterByType('vehicleLicensePlate'),
      this.handleFilterByType('parking-status'),
      this.handleFilterByType('create-by'),
      this.handleFilterByType('problem'),
      fromDate ? dateYYYYMMDD(fromDate) : null,
      toDate ? dateYYYYMMDD(toDate) : null,
      pageSize.value,
      (pageSize.value * pageNumber) - pageSize.value >= 0 ? (pageSize.value * pageNumber) - pageSize.value : 0,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      this.handleFilterByType('vehicle-type'),
      this.handleFilterByType('customer-type'),
      this.handleFilterByType('parkingRef'),
    ));
  }

  handleSelectDate = (fromDate, toDate, selectTypeDate) => {
    const { sort } = this.state;

    this.setState({ fromDate, toDate, selectTypeDate, 'loading': true, 'pageSize': commonConstant.defaultPageSize, 'pageNumber': 1 });
    return this.props.dispatch(fetchGetParkingReport(
      this.props.match.params.buildingRefNo,
      this.handleFilterByType('vehicleLicensePlate'),
      this.handleFilterByType('parking-status'),
      this.handleFilterByType('create-by'),
      this.handleFilterByType('problem'),
      dateYYYYMMDD(fromDate),
      dateYYYYMMDD(toDate),
      commonConstant.defaultPageSize.value,
      0,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      this.handleFilterByType('vehicle-type'),
      this.handleFilterByType('customer-type'),
      this.handleFilterByType('parkingRef'),
    ));
  }

  handleShowModal = value => this.setState({
    'modal': this.state.modal ? null : value,
    'selectFilterCheckbox': { ...this.state.filterCheckbox }, // clear filter on modal (unapply)
  });

  handleFilterModal = key => { // handle filter modal (checkbox)
    this.setState({
      'selectFilterCheckbox': {
        ...this.state.selectFilterCheckbox,
        [key]: { ...this.state.selectFilterCheckbox[key], 'select': !this.state.selectFilterCheckbox[key].select },
      },
    });
  }

  handleApplyFilterModal = () => { // apply filter form modal
    const { sort, fromDate, toDate } = this.state;
    const arr = this.handleBadgesItems();

    this.setState({
      'modal': null,
      'filterCheckbox': { ...this.state.selectFilterCheckbox },
      'selectFilterCheckbox': { ...this.state.selectFilterCheckbox },
      'filter': arr,
      'loading': true,
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
      'sumFilterModal': this.handleSumFilter(),
    });
    return this.props.dispatch(fetchGetParkingReport(
      this.props.match.params.buildingRefNo,
      this.handleFilterByType('vehicleLicensePlate', arr),
      this.handleFilterByType('parking-status', arr),
      this.handleFilterByType('create-by', arr),
      this.handleFilterByType('problem', arr),
      dateYYYYMMDD(fromDate),
      dateYYYYMMDD(toDate),
      commonConstant.defaultPageSize.value,
      0,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      this.handleFilterByType('vehicle-type', arr),
      this.handleFilterByType('customer-type', arr),
      this.handleFilterByType('parkingRef', arr),
    ));
  }

  handleBadgesItems = newFilterInput => { // handle filter for badges
    try {
      const { selectFilterCheckbox, filterInput } = this.state;
      const input = newFilterInput ? newFilterInput : filterInput;
      const arr = input ? [...input] : [];

      Object.keys(selectFilterCheckbox).forEach(key => {
        if (selectFilterCheckbox[key].select) {
          arr.push({
            'label': selectFilterCheckbox[key].label,
            'value': selectFilterCheckbox[key].value,
            'key': 'filterCheckbox',
            'keyName': selectFilterCheckbox[key].keyName,
            'type': selectFilterCheckbox[key].type,
          });
        }
      });
      return arr;
    } catch (error) {
      return null;
    }
  }

  handleInput = event => {
    const { typeSearch, fromDate, toDate } = this.state;

    if (validateVehiclePlate(event.target.value)) {
      if (event.target.value.length >= 3) {
        this.props.dispatch(fetchSearchVehiclePlateOrParkingRefInOperationReport(
          this.props.match.params.buildingRefNo,
          typeSearch === 'vehicleLicensePlate' && event.target.value,
          typeSearch === 'parkingRef' && event.target.value,
          dateYYYYMMDD(fromDate),
          dateYYYYMMDD(toDate),
          this.handleFilterByType('vehicle-type'),
        ));
        return this.setState({ 'inputFilter': event.target.value });
      }
      return this.setState({ 'inputFilter': event.target.value, 'showAutoFill': false });
    }
  }

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      return this.handleFilterInput();
    }
  }

  handleFilterInput = async selectFilter => { // add filter from input
    const { inputFilter, filterInput, fromDate, toDate, sort, typeSearch } = this.state;
    const input = selectFilter ? selectFilter : inputFilter;
    const check = await filterInput.find(element => element.value === input);

    if (check || !inputFilter) {
      return null;
    }
    const newFilterInput = [...filterInput, {
      'label': input,
      'value': input,
      'key': 'filterInput',
      'keyName': input,
      'type': typeSearch,
    }];
    const arr = this.handleBadgesItems(newFilterInput);

    this.setState({
      'filterInput': newFilterInput,
      'filter': arr,
      'inputFilter': '',
      'loading': true,
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
      'showAutoFill': false,
      'dataAutoFill': null,
    });

    return this.props.dispatch(fetchGetParkingReport(
      this.props.match.params.buildingRefNo,
      this.handleFilterByType('vehicleLicensePlate', arr),
      this.handleFilterByType('parking-status', arr),
      this.handleFilterByType('create-by', arr),
      this.handleFilterByType('problem', arr),
      dateYYYYMMDD(fromDate),
      dateYYYYMMDD(toDate),
      commonConstant.defaultPageSize.value,
      0,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      this.handleFilterByType('vehicle-type', arr),
      this.handleFilterByType('customer-type', arr),
      this.handleFilterByType('parkingRef', arr),
    ));
  }

  handleRemoveFilter = index => { // remove filter from badges
    const { filter, filterInput, filterCheckbox, fromDate, toDate, sort } = this.state;
    let newFilterInput = null;

    if (filter[index].key === 'filterInput') {
      newFilterInput = filterInput.filter(element => element.label !== filter[index].label);
    } else if (filter[index].key === 'filterCheckbox') {
      filterCheckbox[filter[index].keyName].select = false;
    }
    const arr = this.handleBadgesItems(newFilterInput ? newFilterInput : null);

    this.setState({
      'filter': arr,
      filterCheckbox,
      'filterInput': newFilterInput ? newFilterInput : filterInput,
      'loading': true,
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
    });
    return this.props.dispatch(fetchGetParkingReport(
      this.props.match.params.buildingRefNo,
      this.handleFilterByType('vehicleLicensePlate', arr),
      this.handleFilterByType('parking-status', arr),
      this.handleFilterByType('create-by', arr),
      this.handleFilterByType('problem', arr),
      dateYYYYMMDD(fromDate),
      dateYYYYMMDD(toDate),
      commonConstant.defaultPageSize.value,
      0,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      this.handleFilterByType('vehicle-type', arr),
      this.handleFilterByType('customer-type', arr),
      this.handleFilterByType('parkingRef', arr),
    ));
  }

  handleFilterByType = (type, filter) => {
    const newFilter = filter ? filter : this.state.filter;
    const arr = [];

    newFilter.forEach(ele => ele.type === type ? arr.push(trimSpace(ele.value)) : null);
    if ((type === 'parking-status' || type === 'create-by') && arr.length === 2) { // check filter parking-status and create-by is check all return null to query param
      return null;
    }
    return arr.join(',');
  }

  handleHeaderModal = () => {
    const { modal } = this.state;

    switch (modal) {
      case 'filter':
        return this.handleSumFilter();
      case 'createParking':
        return 'สร้างรายการใหม่';
      default:
        return;
    }
  }

  handleBodyModal = () => {
    const { modal, selectFilterCheckbox } = this.state;

    switch (modal) {
      case 'filter':
        return (
          <div className="filter-box">
            <div className="select-filter">
              <div className="type">
                <div className="title mt">สถานะรถ</div>
                <Checkbox
                  id="filter-car-in"
                  label={selectFilterCheckbox.in.label}
                  checked={selectFilterCheckbox.in.select}
                  handleSelect={() => this.handleFilterModal('in')}
                />
                <Checkbox
                  id="filter-car-out"
                  label={selectFilterCheckbox.out.label}
                  checked={selectFilterCheckbox.out.select}
                  handleSelect={() => this.handleFilterModal('out')}
                />
                <div className="title">การสร้างข้อมูล</div>
                <Checkbox
                  id="filter-auto-create"
                  label={selectFilterCheckbox.auto.label}
                  checked={selectFilterCheckbox.auto.select}
                  handleSelect={() => this.handleFilterModal('auto')}
                />
                <Checkbox
                  id="filter-manual-create"
                  label={selectFilterCheckbox.manual.label}
                  checked={selectFilterCheckbox.manual.select}
                  handleSelect={() => this.handleFilterModal('manual')}
                />
                <div className="title">ประเภทรถ</div>
                <Checkbox
                  id="filter-car"
                  label={selectFilterCheckbox.car.label}
                  checked={selectFilterCheckbox.car.select}
                  handleSelect={() => this.handleFilterModal('car')}
                />
                <Checkbox
                  id="filter-motorcycle"
                  label={selectFilterCheckbox.motorcycle.label}
                  checked={selectFilterCheckbox.motorcycle.select}
                  handleSelect={() => this.handleFilterModal('motorcycle')}
                />
              </div>
              <div className="type">
                <div className="title mt">ปัญหาที่พบ</div>
                <Checkbox
                  id="filter-problem-barrier"
                  label={selectFilterCheckbox.barrier.label}
                  checked={selectFilterCheckbox.barrier.select}
                  handleSelect={() => this.handleFilterModal('barrier')}
                />
                <Checkbox
                  id="filter-problem-payment"
                  label={selectFilterCheckbox.payment.label}
                  checked={selectFilterCheckbox.payment.select}
                  handleSelect={() => this.handleFilterModal('payment')}
                />
                <Checkbox
                  id="filter-problem-red-license-plate"
                  label={selectFilterCheckbox.readVehicleLicensePlate.label}
                  checked={selectFilterCheckbox.readVehicleLicensePlate.select}
                  handleSelect={() => this.handleFilterModal('readVehicleLicensePlate')}
                />
                <Checkbox
                  id="filter-problem-physical-damage"
                  label={selectFilterCheckbox.physicalDamage.label}
                  checked={selectFilterCheckbox.physicalDamage.select}
                  handleSelect={() => this.handleFilterModal('physicalDamage')}
                />
                <Checkbox
                  id="filter-problem-overdue"
                  label={selectFilterCheckbox.overdue.label}
                  checked={selectFilterCheckbox.overdue.select}
                  handleSelect={() => this.handleFilterModal('overdue')}
                />
                <Checkbox
                  id="filter-problem-other"
                  label={selectFilterCheckbox.other.label}
                  checked={selectFilterCheckbox.other.select}
                  handleSelect={() => this.handleFilterModal('other')}
                />
                <Checkbox
                  id="filter-problem-empty"
                  label={selectFilterCheckbox.noProblem.label}
                  checked={selectFilterCheckbox.noProblem.select}
                  handleSelect={() => this.handleFilterModal('noProblem')}
                />
                <div className="title">ประเภทลูกค้า</div>
                <Checkbox
                  id="filter-visitor"
                  label={selectFilterCheckbox.visitor.label}
                  checked={selectFilterCheckbox.visitor.select}
                  handleSelect={() => this.handleFilterModal('visitor')}
                />
                <Checkbox
                  id="filter-member"
                  label={selectFilterCheckbox.member.label}
                  checked={selectFilterCheckbox.member.select}
                  handleSelect={() => this.handleFilterModal('member')}
                />
              </div>
            </div>
            <div className="box-btn">
              <Button className="btn-primary" id="btn-apply-filter" onClick={this.handleApplyFilterModal}>
                Apply
              </Button>
            </div>
          </div>
        );
      case 'viewDetail':
        return <ParkingDetail handleCloseModal={this.handleShowModal} />;
      case 'createParking':
        return <CreateParking />;
      default:
        return;
    }
  }

  handleClearState = nextProps => {
    const props = nextProps ? nextProps : this.props;
    this.setState({
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
      'sort': commonConstant.defaultSortParkingReport,
      'inputFilter': '',
      'filter': [],
      'filterCheckbox': {
        ...JSON.parse(commonConstant.defaultFilterParkingStatus),
        ...JSON.parse(commonConstant.defaultFilterCreateBy),
        ...JSON.parse(commonConstant.defaultFilterProblem),
        ...JSON.parse(commonConstant.defaultFilterVehicleType),
        ...JSON.parse(commonConstant.defaultFilterCustomerType),
      },
      'selectFilterCheckbox': {
        ...JSON.parse(commonConstant.defaultFilterParkingStatus),
        ...JSON.parse(commonConstant.defaultFilterCreateBy),
        ...JSON.parse(commonConstant.defaultFilterProblem),
        ...JSON.parse(commonConstant.defaultFilterVehicleType),
        ...JSON.parse(commonConstant.defaultFilterCustomerType),
      },
      'filterInput': [],
      'fromDate': dateYYYYMMDD(new Date()),
      'toDate': dateYYYYMMDD(new Date()),
      'selectTypeDate': 1,
      'loading': true,
      'modal': null,
    });
    return this.props.dispatch(fetchGetParkingReport(
      props.match.params.buildingRefNo,
      null,
      null,
      null,
      null,
      dateYYYYMMDD(new Date()),
      dateYYYYMMDD(new Date()),
      commonConstant.defaultPageSize.value,
      0,
      commonConstant.defaultSortParkingReport.key,
      commonConstant.defaultSortParkingReport.sort ? 'descending' : 'ascending',
      null,
      null,
    ));
  }

  handleViewDetail = item => {
    this.setState({ 'loading': true });
    return this.props.dispatch(fetchGetParkingStatusById(item.parkingID), vehicleType(item));
  };

  handleCreateParking = () => this.setState({ 'modal': 'createParking' });

  handleCallUpdateDataReport = () => {
    const { fromDate, toDate, pageSize, pageNumber, sort } = this.state;

    return this.props.dispatch(fetchGetParkingReport(
      this.props.match.params.buildingRefNo,
      this.handleFilterByType('vehicleLicensePlate'),
      this.handleFilterByType('parking-status'),
      this.handleFilterByType('create-by'),
      this.handleFilterByType('problem'),
      fromDate ? dateYYYYMMDD(fromDate) : null,
      toDate ? dateYYYYMMDD(toDate) : null,
      pageSize.value,
      (pageSize.value * pageNumber) - pageSize.value >= 0 ? (pageSize.value * pageNumber) - pageSize.value : 0,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      this.handleFilterByType('vehicle-type'),
      this.handleFilterByType('customer-type'),
      this.handleFilterByType('parkingRef'),
    ));
  }

  handleSumFilter = () => {
    const { selectFilterCheckbox } = this.state;
    let sum = 0;

    Object.keys(selectFilterCheckbox).forEach(ele => selectFilterCheckbox[ele].select ? sum += 1 : null);

    return (
      <span className="box-sum">
        <span>Filter</span>
        {sum ? <span className="sum" id="filter-summary">{sum}</span> : null}
      </span>
    );
  }

  handleResetFilter = () => {
    const { fromDate, toDate, filterInput } = this.state;

    this.setState({
      'loading': true,
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
      'sort': commonConstant.defaultSortParkingReport,
      'filter': [...filterInput],
      'filterCheckbox': {
        ...JSON.parse(commonConstant.defaultFilterParkingStatus),
        ...JSON.parse(commonConstant.defaultFilterCreateBy),
        ...JSON.parse(commonConstant.defaultFilterProblem),
        ...JSON.parse(commonConstant.defaultFilterVehicleType),
        ...JSON.parse(commonConstant.defaultFilterCustomerType),
      },
      'selectFilterCheckbox': {
        ...JSON.parse(commonConstant.defaultFilterParkingStatus),
        ...JSON.parse(commonConstant.defaultFilterCreateBy),
        ...JSON.parse(commonConstant.defaultFilterProblem),
        ...JSON.parse(commonConstant.defaultFilterVehicleType),
        ...JSON.parse(commonConstant.defaultFilterCustomerType),
      },
      'sumFilterModal': 0,
    });

    return this.props.dispatch(fetchGetParkingReport(
      this.props.match.params.buildingRefNo,
      this.handleFilterByType('vehicleLicensePlate'),
      this.handleFilterByType('parking-status'),
      this.handleFilterByType('create-by'),
      this.handleFilterByType('problem'),
      dateYYYYMMDD(fromDate),
      dateYYYYMMDD(toDate),
      commonConstant.defaultPageSize.value,
      0,
      commonConstant.defaultSortParkingReport.key,
      commonConstant.defaultSortParkingReport.sort ? 'descending' : 'ascending',
      this.handleFilterByType('vehicle-type'),
      this.handleFilterByType('customer-type'),
      this.handleFilterByType('parkingRef'),
    ));
  }

  handleItemsAutoFill = getVehicleLicensePlate => {
    try {
      if (!getVehicleLicensePlate.data) {
        return null;
      }
      const dataAutoFill = getVehicleLicensePlate.data.map((ele, index) => (
        <span key={randomNumber()}>
          <span id={`search-license-plate-auto-fill-${index}`}>
            {validateToShowDash(vehicleLicensePlate(ele))}
          </span>
          <IconVehicle className="icon" name={vehicleTypeIconName(vehicleType(ele))}/>
        </span>
      ));

      return this.setState({ dataAutoFill, 'showAutoFill': true });
    } catch (error) {
      return null;
    }
  }

  handleTypeSearch = typeSearch => {
    const { fromDate, toDate, inputFilter } = this.state;

    this.setState({ typeSearch });
    return this.props.dispatch(fetchSearchVehiclePlateOrParkingRefInOperationReport(
      this.props.match.params.buildingRefNo,
      typeSearch === 'vehicleLicensePlate' && inputFilter,
      typeSearch === 'parkingRef' && inputFilter,
      dateYYYYMMDD(fromDate),
      dateYYYYMMDD(toDate),
      this.handleFilterByType('vehicle-type'),
    ));
  }

  render() {
    const {
      inputFilter,
      selectTypeDate,
      fromDate,
      toDate,
      filter,
      modal,
      pageNumber,
      pageSize,
      sort,
      loading,
      showAutoFill,
      dataAutoFill,
      typeSearch,
    } = this.state;
    const { getParkingReport, getProfile, getBuildingByRefNo } = this.props;

    if (!getProfile.data || !getParkingReport.data || !getBuildingByRefNo) {
      return <Loading/>;
    }

    return (
      <div className="OperationReport layout-box-page">
        {loading ? <Loading/> : null}
        <div className="type-search-box">
          <RadioButton
            id="filter-search-by-vehicle-license-plate"
            checked={typeSearch === 'vehicleLicensePlate'}
            label="ค้นหาจากทะเบียนรถ"
            handleSelect={() => this.handleTypeSearch('vehicleLicensePlate')}
          />
          <RadioButton
            id="filter-search-by-parking-ref"
            checked={typeSearch === 'parkingRef'}
            label="ค้นหาจากรหัสอ้างอิง"
            handleSelect={() => this.handleTypeSearch('parkingRef')}
          />
        </div>
        <div className="tool-bar">
          <div className="box-filter">
            <InputWithIcon
              id="search-license-plate"
              template="b"
              value={inputFilter}
              icon="fas fa-search"
              placeholder="ค้นหาจากเลขทะเบียนรถ"
              onKeyPress={this.handleKeyPress}
              onChange={this.handleInput}
              showAutoFill={showAutoFill}
              maxLength="9"
              dataAutoFill={dataAutoFill}
            />
            <Button className="btn-secondary btn-filter" id="btn-filter" onClick={() => this.handleShowModal('filter')}>
              Filter
              <span className="icon fas fa-filter" />
            </Button>
            <span className="label-date">ช่วงเวลา</span>
            <DatePicker
              placeholder="เลือกช่วงเวลา"
              selectType={selectTypeDate}
              fromDate={fromDate}
              toDate={toDate}
              handleSelectDate={this.handleSelectDate}
            />
          </div>
          <div className="box-create">
            <Button
              id="btn-create-parking"
              className="btn-primary btn-excel"
              onClick={this.handleCreateParking}
            >
              <span className="icon icon-add" />
              สร้างรายการใหม่
            </Button>
          </div>
        </div>
        <Badges items={filter} handleRemove={this.handleRemoveFilter} />
        <div className={`section-table${filter.length > 0 ? ' mr' : ''}`}>
          <div className="box-detail">
            <span>
              จำนวนรถทั้งหมด
              <span className="green" id="total-vehicle">{validateToShowDash(totalVehicles(getParkingReport) ? totalVehicles(getParkingReport).toLocaleString() : null)}</span>
              คัน
            </span>
            <span>
              <IconVehicle className="icon" name="icon_car" />
              <span className="green" id="total-car">{validateToShowDash(totalCar(getParkingReport) ? totalCar(getParkingReport).toLocaleString() : null)}</span>
              คัน
            </span>
            <span>
              <IconVehicle className="icon" name="icon_motorcycle" />
              <span className="green" id="total-motorcycle">{validateToShowDash(totalMotorcycle(getParkingReport) ? totalMotorcycle(getParkingReport).toLocaleString() : null)}</span>
              คัน
            </span>
          </div>
          <Table
            id="table-operation-report"
            columnHeader={columnHeader}
            data={getParkingReport.data}
            passFuncBody={this.passFuncBody}
            maxData={validateToShowDash(totalRecords(getParkingReport))}
            pageSize={pageSize}
            pageNumber={pageNumber}
            handlePageChange={this.handlePageChange}
            sort={sort}
            isSort
            handleSort={this.handleSort}
            handlePageSize={this.handlePageSize}
            filter={filter}
            passFuncClick={{
              'viewDetail': this.handleViewDetail,
            }}
          />
        </div>
        <Modal
          show={modal ? true : false}
          header={this.handleHeaderModal()}
          handleToggle={this.handleShowModal}
          iconOther={
            modal === 'filter' ?
              <span className="reset" id="modal-reset-filter" onClick={this.handleResetFilter}>
                <span className="icon fas fa-redo-alt" />
                <span className="text">Reset</span>
              </span>
              : null
          }
        >
          {this.handleBodyModal()}
        </Modal>
      </div>
    );
  }
}

OperationReport.propTypes = {
  'dispatch': PropTypes.func.isRequired,
  'match': PropTypes.shape({
    'params': PropTypes.shape({
      'buildingRefNo': PropTypes.string.isRequired,
      'buildingID': PropTypes.string.isRequired,
    }),
    'url': PropTypes.string,
  }),
  'getParkingReport': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.array,
    'metadata': PropTypes.shape({
      'pagination': PropTypes.shape({
        'totalRecords': PropTypes.number,
      }),
      'summary': PropTypes.shape({
        'totalVehicles': PropTypes.number,
        'totalNetParkingFees': PropTypes.number,
      }),
    }),
  }),
  'getProfile': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({
      'building': PropTypes.shape({
        'buildingRefNo': PropTypes.string,
        'buildingID': PropTypes.string,
      }),
    }),
  }),
  'getParkingStatusById': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({}),
  }),
  'getParkingStatus': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({}),
  }),
  'getParkingProblems': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({}),
  }),
  'createParking': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({}),
  }),
  'getBuildingByRefNo': PropTypes.shape({}),
  'carExit': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({}),
  }),
  'deleteProblem': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({}),
  }),
  'createProblem': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({
      'parkingID': PropTypes.string,
    }),
  }),
  'updateProblem': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({
      'parkingID': PropTypes.string,
    }),
  }),
  'getVehicleLicensePlate': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({}),
  }),
  'searchVehiclePlateOrParkingRefInOperationReport': PropTypes.shape({
    'metadata': PropTypes.shape({
      'searchKeywords': PropTypes.shape({
        'vehicleLicensePlates': PropTypes.string,
        'parkingRefNos': PropTypes.string,
      }),
    }),
  }),
  'iotDevices': PropTypes.shape({
    'data': PropTypes.shape({}),
  }),
};

const mapStateToProps = ({
  getParkingReport,
  getProfile,
  getParkingStatusById,
  getParkingStatus,
  createParking,
  getBuildingByRefNo,
  carExit,
  deleteProblem,
  createProblem,
  updateProblem,
  getVehicleLicensePlate,
  searchVehiclePlateOrParkingRefInOperationReport,
  iotDevices,
}) => ({
  getParkingReport,
  getProfile,
  getParkingStatusById,
  getParkingStatus,
  createParking,
  'getBuildingByRefNo': getBuildingByRefNo.data,
  carExit,
  deleteProblem,
  createProblem,
  updateProblem,
  getVehicleLicensePlate,
  searchVehiclePlateOrParkingRefInOperationReport,
  iotDevices,
});

export default connect(mapStateToProps)(OperationReport);
